// @flow
//eslint-disable-next-line

import React from 'react'
import { useSelector } from 'react-redux'

import { Accordion } from 'react-bootstrap'
import { scroller } from 'react-scroll'

import { CartActions } from '../../../../../containers'
import { useTranslation } from '../../../../../hooks'
import {
	APP_HELPER,
	MANAGE_CART_HELPER,
	CART_HELPER,
	HELPER,
	CONSTANTS,
	PRODUCT_HELPER,
} from '../../../../../utils'

const cart_misc_fee = []

function MenuWrapper() {
	const translate = useTranslation()

	const { currency_code } = useSelector((state) => state.config.merchant)
	const { sub_total_amount, items, count } = useSelector((state) => state.cart.cart_items)

	const showMiscReceiptInfo = () => {
		return cart_misc_fee.map((fee, i) => {
			let feeValue = HELPER.parseToFloat(fee?.value, 2)
			return (
				<div className="receiptSubItems" key={i}>
					<span className="left">{fee?.key}:</span>
					<span className="right" dir={APP_HELPER.GET_LANG_DIRECTION()}>
						{MANAGE_CART_HELPER.formatCharges(currency_code, feeValue, true)}
					</span>
				</div>
			)
		})
	}

	const showReceiptInfo = (translation_key, value, isDiscount = false, showMiscCharges = '') => {
		return (
			<>
				<div className="receiptSub bigReceiptHeadingBox" key={translation_key}>
					<span className="left">{translate(translation_key)}:</span>
					<span className="right" dir={APP_HELPER.GET_LANG_DIRECTION()}>
						{isDiscount ? '- ' : ''}
						{MANAGE_CART_HELPER.formatCharges(currency_code, HELPER.parseToFloat(value, 2))}
					</span>
				</div>
				{showMiscCharges && !HELPER.isEmpty(cart_misc_fee) ? showMiscReceiptInfo() : ''}
			</>
		)
	}

	/*
        const showDiscountInfo = (translation_key, value) => {
            return (
                <>
                    <div className="receiptDiscounts d-none">
                        {showDiscountBreakdown()}
                        <div className="receiptInfo discountMainHeadingBox">
                            {showReceiptInfo(translation_key, value, true)}
                        </div>
                    </div>
                </>
            );
        };
    
        const showDiscountBreakdown = () => {
            const voucher_details = {
                name: "Voucher code",
                type: 1,
                value: 500.07,
            }
            const discount_details = {
                name: "Voucher code",
                type: 0,
                value: 500.07,
            }
            return (
                <>
                    {showDiscountBreakdownInfo("vouch", voucher_details)}
                    {showDiscountBreakdownInfo("discount", discount_details)}
                </>
            );
        };
    
        const showDiscountBreakdownInfo = (translation_key, discount) => {
            return (
                <>
                    <div className="receiptInfo">
                        <div className="receiptSub" key={"d-" + 1}>
                            <span className="left">
                                <div>
                                    <p>
                                        <span className="discount-tag"></span>
                                        <span dir={CONSTANTS.LANG_DIRECTION.LTR}>{discount?.name} </span>
                                        <span className="close-discount">
                                            <CloseIcon />{" "}
                                        </span>
                                    </p>
                                    <span className="discount-pricing">
                                        {MANAGE_CART_HELPER.formatCharges(
                                            currency_code,
                                            discount?.value ?? 0,
                                            false
                                        ) +
                                            " " +
                                            translate("CART.OFF") + "% "}
                                    </span>{" "}
                                </div>
                            </span>
                            <span
                                className="right"
                                dir={APP_HELPER.GET_LANG_DIRECTION()}
                            >
                                - {MANAGE_CART_HELPER.formatCharges(currency_code, discount?.amount)}
                            </span>
                        </div>
                    </div>
                </>
            );
        };
    
    */

	return (
		<div
			className={`cartSlide ${
				CART_HELPER.CART_DEVICE_TYPE() === CONSTANTS.DEVICE_TYPE.MOBILE ? 'webCartSlide' : ''
			}  $;{count > 0 ? "" : "d-none"}`}
		>
			<div
				className={`cartSlideHeader ${
					CART_HELPER.CART_DEVICE_TYPE() === CONSTANTS.DEVICE_TYPE.MOBILE ? 'd-none' : ''
				}`}
			>
				<div className="cartSlideHeaderContainer">
					<span>Your bag has ({count}) items</span>
				</div>
			</div>
			<div className="insideCartSlideWrap">
				<div className="insideWrapper">
					{items.map((cart_item, i) => {
						return (
							<div className="cartProductsWrap" key={i}>
								<div className="cartPrdLeft">
									<span className="cartProdName">
										{PRODUCT_HELPER.FORMAT_PRODUCT_NAME(cart_item?.product)}
										{cart_item?.product?.has_variants ? (
											<span className="cartVariations">
												{cart_item?.product?.selected_variant?.variant_name}
											</span>
										) : (
											''
										)}
									</span>
									<span className="cartAddNotes">
										{PRODUCT_HELPER.DISPLAY_ADDITIONAL_NOTES(cart_item?.product, false)}
									</span>
									<div className="slideProdPrice suggestPrice strikeText">
										{PRODUCT_HELPER.FORMAT_PRICE(cart_item?.product)}
									</div>
									<div className="slideProdPrice newPrice">
										{PRODUCT_HELPER.FORMAT_DISCOUNTED_PRICE(cart_item?.product)}
									</div>
									<CartActions product={cart_item?.product} />
								</div>
								<div className="cartPrdRight">
									<div className="cartProdImgWrap">
										<img
											src={PRODUCT_HELPER.PRODUCT_IMAGE(cart_item?.product).src}
											alt={PRODUCT_HELPER.PRODUCT_IMAGE(cart_item?.product).alt}
										/>
									</div>
								</div>
							</div>
						)
					})}
				</div>
				<div className={'cartMenu nestedAccordion'}>
					<Accordion defaultActiveKey={0}>
						<Accordion.Toggle eventKey={1} as={'div'} component={'div'}>
							<div
								onClick={() =>
									scroller.scrollTo('bigReceiptHeadingBox', { offset: -200, smooth: true })
								}
								className="billingDetailsSlide"
							>
								<i className="new-icon-billing"></i>
								<span>{translate('CART.BILLING_INFO')}</span>
								<i className="icon-icon-caret-down"></i>
							</div>
						</Accordion.Toggle>
						<Accordion.Collapse eventKey={1} className="billingDetailsWrap">
							<div className="receiptSection">
								<div className="subTotalDetails">
									{/* SUB-TOTAL */}
									{showReceiptInfo('CART.SUB_TOTAL', sub_total_amount, false, true)}
									{/* SUB-TOTAL */}
									<div className="insidesubTotalBox d-none">
										<div className="left">Builder Shipping</div>
										<div className="right">PKR 283</div>
									</div>
									<div className="insidesubTotalBox d-none">
										<div className="left">Builder Voucher</div>
										<div className="right">-PKR. 283</div>
									</div>
								</div>
								<div className="shippingFee d-none">
									<div className="shippingSubInfo">
										<div className="left">Shipping Fee:</div>
										<div className="right">PKR. 50</div>
									</div>
								</div>

								{/* DISCOUNT CHARGES */}
								{/* {showDiscountInfo("CART.DISCOUNT", 700, false)} */}
								{/* DISCOUNT CHARGES */}
							</div>
						</Accordion.Collapse>
					</Accordion>
				</div>
			</div>
			<div className={`cartSlideTotal`}>
				<div className="cartSlideTotalContainer">
					<span>{translate('CART.TOTAL')}</span>
					<span className="cartSlideTotalAmount">
						<span>{HELPER.formatPrice(currency_code, sub_total_amount).currency}</span>
						{HELPER.formatPrice(currency_code, sub_total_amount).charges}
					</span>
				</div>
			</div>
		</div>
	)
}

export default MenuWrapper
